<template>
  <div class="home" ref="home">
    <!-- pc代码 -->
    <div v-if="pageType == 'pc'">
      <!-- 页面头部 -->
      <div>
        <pageHeader ref="pageHeader" pageStatus="1" />
      </div>
      <!-- 轮播图 -->
      <div class="swiper_banner">
        <Banner ref="Swiper" />
        <sampleDealStatus class="sample_deal_status" />
        <laboratoryQuerySelect class="laboratory_query_banner" type="home" />
      </div>
      <!-- 交易状态 -->
      <div class="sample_deal_status"></div>
      <!-- 实验室搜索 -->
      <div class="laboratory_query_banner"></div>
      <!-- <Swiper ref="Swiper" /> -->
      <!-- 内容 -->
      <div class="contents contents1 ph">
        <div
          v-for="(item, index) in contList"
          :key="index"
          class="contents_box"
        >
          <div class="contents_ever" v-if="item.type != 11">
            <!-- 标题 -->
            <div class="ever_title_left" ref="solution">
              <div class="ever_title_left_title">
                <span class="ever_title_left_text">{{ item.name }}</span>
                <p>{{ commonClass === "ph" ? item.mobiledesc : item.desc }}</p>
              </div>
            </div>
            <!-- 行业解决方案 -->
            <div v-if="item.type == 1" class="detection_solution">
              <!-- pc -->
              <div class="ever_content1">
                <div
                  class="col_ever col_ever2"
                  v-for="(item, index) in hotlist"
                  :key="index"
                  @mouseenter="handleMouseenter(index)"
                  @mouseleave="handleMouseleave(index)"
                  @click="toDetail(item)"
                  style="background: #eaebee"
                >
                  <div
                    :class="
                      isShowPro && index === current
                        ? 'col_ever_hover col_ever_text'
                        : 'col_ever_text'
                    "
                  >
                    <div class="col_ever_title">{{ item.name }}</div>
                    <div
                      v-if="isShowPro && index === current"
                      class="col_ever_text_imageTitle"
                    >
                      {{ item.remark }}
                    </div>
                    <a :href="'/detection?id=' + item.id">
                      <div class="col_ever_more" type="">查看更多</div>
                    </a>
                  </div>
                  <img
                    :style="{
                      borderRadius: isShowPro && index === current ? '4px' : '',
                    }"
                    class="col_ever_img"
                    :src="$path + item.subjectImageUrl"
                    alt
                  />
                </div>
              </div>
              <!-- 移动端 -->
              <div class="swiper-container hotList" id="hotList">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(hotlistTab1, index) in hotlistTab"
                    :key="index"
                  >
                    <div
                      class="col_ever"
                      v-for="(item, index) in hotlistTab1"
                      :key="index"
                      @click="toDetail(item)"
                      style="width: 48%; background: #eaebee"
                    >
                      <div
                        :class="
                          isShowPro && index === current
                            ? 'col_ever_hover col_ever_text one_hidden'
                            : 'col_ever_text one_hidden'
                        "
                      >
                        <div class="col_ever_title">{{ item.name }}</div>
                        <div
                          v-if="isShowPro && index === current"
                          class="col_ever_text_imageTitle"
                        >
                          {{ item.remark }}
                        </div>
                      </div>
                      <img
                        :style="{
                          borderRadius:
                            isShowPro && index === current ? '4px' : '',
                        }"
                        class="col_ever_img"
                        :src="$path + item.subjectImageUrl"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
              </div>
            </div>
            <!-- 国联硬实力 -->
            <div class="unqd_strength_box" v-if="item.type == 2">
              <ul class="unqd_strength">
                <li
                  :class="
                    isStrengthShow && index === strengthCurrent
                      ? 'unqd_strength_show'
                      : ''
                  "
                  v-for="(item, index) in unqd_strength"
                  :key="item.id"
                  @mouseenter="handleStrength(index)"
                  @mouseleave="handleStrengthLeave(index)"
                >
                  <div class="unqd_strength_cont">
                    <img
                      :src="
                        isStrengthShow && index === strengthCurrent
                          ? item.select
                          : item.icon
                      "
                      alt=""
                    />
                    <div class="unqd_strength_cont_desc">{{ item.desc }}</div>
                  </div>
                  <img class="unqd_strength-img" :src="item.url" alt="" />
                </li>
              </ul>
            </div>
            <!-- 行业客户 -->
            <div v-if="item.type == 3" class="industry_customers">
              <ul>
                <li
                  v-for="item in customersList"
                  :key="item.id"
                  style="background: #eaebee"
                >
                  <img :src="$path + item.image" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- pc端 -->
      <div class="contents contents2 pc">
        <!-- 行业解决方案 -->
        <div class="contents_box">
          <div style="margin-top: 40px" class="contents_ever">
            <div class="ever_title_left" ref="solution">
              <div class="ever_title_left_title">
                <span class="ever_title_left_text">行业解决方案</span>
                <p>
                  国联秉承满足并超越客户期望的客户价值导向原则，为多行业客户高质量发展保驾护航
                </p>
              </div>
            </div>
          </div>
          <div
            class="solution_level"
            v-for="(item, index) in jiejueList"
            :key="index"
          >
            <div
              class="contents_nav"
              :class="{ 'contents_nav-first': index === 0 }"
            >
              <div
                :class="category.isshow ? 'active' : ''"
                v-for="(category, ins) in item.categoryClientList"
                :key="ins"
                @click="jiejueListchange(index, ins)"
              >
                {{ category.categoryName }}
              </div>
            </div>
            <div
              v-for="(categorys, indexs) in item.categoryClientList"
              :key="indexs"
            >
              <div v-if="categorys.isshow" class="solution_level_box">
                <div
                  class="solution_level1"
                  style="cursor: pointer"
                  @click="$router.push('/detection?id=' + categorys.categoryId)"
                  :style="{
                    'background-image':
                      'url(' + $path + categorys.categoryImgUrl + ')',
                  }"
                >
                  <div class="mask"></div>
                  <div class="desc">
                    <span class="desc1">{{ categorys.categoryName }}</span>
                    <span class="desc2">{{ categorys.categorySummary }}</span>
                    <span class="desc3">
                      <a
                        :href="'/detection?id=' + categorys.categoryId"
                        class="more_btn"
                        >查看更多 >
                      </a>
                    </span>
                  </div>
                </div>
                <div class="solution_level2">
                  <a
                    class="solution_level2_item"
                    style="cursor: pointer"
                    v-for="(product, indexd) in categorys.productInfo"
                    :key="indexd"
                    :href="'/detectionDetail?id=' + product.productId"
                    target="_blank"
                  >
                    <div
                      class="level2_item_image"
                      :style="{
                        'background-image':
                          'url(' + $path + product.productImgUrl + ')',
                      }"
                    ></div>
                    <div class="level2_item_center1">
                      {{ product.productName }}
                    </div>
                    <div class="level2_item_center2">
                      {{ product.productSummary }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="show53"
          style="cursor: pointer"
          id="consult-solution"
          @click="show53"
        >
          咨询更多产品 >
        </div>
        <div class="bigswiper-center">
          <div class="bigswiper-center-title">热门检测套餐</div>
          <div class="bigswiper-center-inner">
            国联打造标准化检测套餐，为客户提供更加简单高效的检测方案
          </div>
          <div class="toall">
            <a class="allset" :href="'/standardSetMeal'" target="_blank"
              >查 看 全 部 套 餐 <span class="allset-inner">^</span></a
            >
            <div class="swiper-container swiper-no-swiping" id="swiper0">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  :key="i"
                  v-for="(hotitem, i) in hotProductData"
                >
                  <div class="swiper-slides-item">
                    <div class="del-margin">
                      <div
                        :class="['transition-box', 'activebox']"
                        style="margin: 0"
                      >
                        <div
                          :style="{
                            'background-image':
                              'url(' + $path + hotitem.prev.imageUrl + ')',
                          }"
                          class="item-image"
                        />
                        <div class="item-imageshadow" />
                        <div class="index">
                          {{ hotitem.prev.index }}
                        </div>
                        <div class="item-name">
                          {{ hotitem.prev.name }}
                        </div>
                        <div class="yellow-border"></div>
                        <div class="to-details">查看详情</div>
                        <div class="item-center" :style="{webkitBoxOrient:'vertical'}">
                          {{ hotitem.prev.productSummary }}
                        </div>
                      </div>
                    </div>
                    <div class="del-margin">
                      <div
                        :class="['transition-box', 'change-box']"
                        style="margin: 0px 14px"
                      >
                        <a :href="hotitem.current.jumpUrl" target="_blank">
                          <div
                            :style="{
                              'background-image':
                                'url(' + $path + hotitem.current.imageUrl + ')',
                              cursor: 'pointer',
                            }"
                            class="item-image"
                          />
                        </a>
                        <div class="item-imageshadow" />
                        <div class="index">
                          {{ hotitem.current.index }}
                        </div>
                        <a :href="hotitem.current.jumpUrl" target="_blank">
                          <div class="item-name" style="cursor: pointer">
                            {{ hotitem.current.name }}
                          </div>
                        </a>
                        <div class="yellow-border"></div>
                        <a :href="hotitem.current.jumpUrl" target="_blank">
                          <div class="to-details">查看详情 ></div>
                        </a>
                        <a :href="hotitem.current.jumpUrl" target="_blank">
                          <div style="cursor: pointer" class="item-center" :style="{webkitBoxOrient:'vertical'}">
                            {{ hotitem.current.productSummary }}
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="del-margin" v-if="hotitem.next">
                      <div
                        :class="['transition-box', 'activebox']"
                        style="margin: 0"
                      >
                        <div
                          :style="{
                            'background-image':
                              'url(' + $path + hotitem.next.imageUrl + ')',
                          }"
                          class="item-image"
                        />
                        <div class="item-imageshadow" />
                        <div class="index">
                          {{ hotitem.next.index }}
                        </div>
                        <div class="item-name">
                          {{ hotitem.next.name }}
                        </div>
                        <div class="yellow-border"></div>
                        <div class="item-center" :style="{webkitBoxOrient:'vertical'}">
                          {{ hotitem.next.productSummary }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev swiper-button-white"></div>
              <div class="swiper-button-next swiper-button-white"></div>
            </div>
          </div>
          <div
            class="hot-set-inner"
            style="cursor: pointer"
            id="consult-hot"
            @click="handleConsult"
          >
            咨询更多产品 >
          </div>
        </div>
        <!-- <div style="background:#fff;width: 100%;">
          <div class="forinchain">实验室遍布全国</div>
          <div class="forinchain-title">2万平米自有智能实验室，2800台高端仪器，200家国内外签约实验室</div>
          <div style="width:100%" class="swiper-container swiper-no-swiping" id="swiper2">
            <div class="swiper-wrapper">
              <div :key="itt.url" v-for="itt in labimageList" style="width:16%;" class="swiper-slide">
                <div><img style="width:100%" :src="$path+itt.url" /></div>
              </div>
            </div>
          </div>
          <div class="advisory-title" style="cursor:pointer;" id="consult-lab" @click="show53">咨询专业工程师 ></div>
        </div> -->
        <!-- 实验室资质认证 -->
        <div
          style="
            background: #f3f4f9;
            width: 100%;
            height: 637px;
            display: flex;
            justify-content: center;
          "
        >
          <div class="labroatory-quality" style="width: 1200px; height: 100%">
            <div class="title-header">
              <div class="title">实验室资质认证</div>
              <div class="tip">专业认可，权威认证，你想要的我们都有</div>
            </div>
            <div class="swiper-warpper">
              <Vswiper
                ref="labroatorySwiper"
                :options="swiperOption"
                style="height: 100%"
              >
                <Swiper-slide v-for="(item, index) in labroatoryQualityList" :key="index" style="border: 2px solid #D7D8DF;overflow: hidden;">
                  <img :src="$path+item.image" alt="" style="height: 100%;position: absolute;left: 50%;transform: translate(-50%, 0);"/>
                </Swiper-slide>
              </Vswiper>
            </div>
            <div class="labroatory-quality-swiper-pagination"></div>
            <div class="swiper-footer">
              <div class="msg">* 资质认证为母公司国联质检所有</div>
              <div class="btns">
                <div class="labroatory-quality-swiper-button-prev" style="outline:none">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="labroatory-quality-swiper-button-next" style="outline:none">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="labroatory-show">
          <div class="labroatory-banner">
            <div class="labroatory-banner-logo">
              <img src="@/assets/laboratory/logo.png" alt="" />
            </div>
            <div class="labroatory-banner-title">
              法定综合性第三方检测认证机构，国联质检旗下综合检测平台
            </div>
          </div>
          <div class="labroatory-content">
            <div class="labroatory-content-map">
              <img src="@/assets/laboratory/home_map.png" alt="" />
            </div>
            <div class="labroatory-content-text">
              <div class="labroatory-content-text-title">实验室遍布全国</div>
              <div class="labroatory-content-text-tip">
                新理念引领研发检验领域的新模式
              </div>
              <div class="labroatory-content-text-btn" id="link-lab" @click="$router.push('/laboratory')">
                了解实验室详情 >
              </div>
            </div>
            <div class="labroatory-content-swiper">
              <Vswiper
                ref="labroatoryVerticalSwiper"
                :options="lavoratorySwiperOption"
                style="height: 100%; width: 212px; margin-left: 0"
              >
                <Swiper-slide v-for="(item, index) in lavoratorySwiperList" :key="index">
                  <img :src="$path+item.url" alt="" style="width: 210px; height: 160px" />
                </Swiper-slide>
              </Vswiper>
              <div class="labroatory-vertical-swiper-pagination"></div>
              <div class="btns">
                <div class="labroatory-vertical-swiper-button-prev" style="outline:none">
                  <i class="el-icon-arrow-up"></i>
                </div>
                <div class="labroatory-vertical-swiper-button-next" style="outline:none">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="special-team">
          <div class="special-team-box">
            <div class="special-team-text">
              <div class="special-team-title">专家团队</div>
              <div class="special-team-tip">
                拥有解决方案、技术、产品、运营、财税等百余位高素质的专家团队
              </div>
            </div>
            <div class="special-team-swiper">
              <Vswiper
                ref="specialTeamSwiper"
                :options="specialTeamSwiperOption"
                style="height: 100%"
              >
                <Swiper-slide
                  class="special-team-swiper-item"
                  v-for="(item, index) in specialTeamSwiperList"
                  :key="index"
                >
                  <img :src="$path+item.image" alt="" />
                </Swiper-slide>
              </Vswiper>
              <div class="btns">
                <div class="special-team-swiper-button-prev" style="outline:none">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="special-team-swiper-button-next" style="outline:none">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cooperative-partner">累计服务超过100000家企业客户</div>
        <div class="cooperative-partner-title">
          覆盖食品、电商、汽车、医疗、化工等众多领域
        </div>
        <div class="blue-center">
          <div style="margin: 0 auto; width: 1272px">
            <div
              style="position: relative; top: -230px; background: #ffffff"
              class="industry_customers"
            >
              <ul>
                <li
                  v-for="item in customersListpc"
                  :key="item.id"
                  style="background: #eaebee"
                >
                  <img :src="$path + item.image" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="news-information">
          <div class="news-information-box">
            <div class="news-information-box-item">
              <div class="news-information-box-title">行业资讯</div>
              <div class="news-information-box-content">
                <p v-for="(item,index) in industryList" :key="index" @click="handleGoNewsDetail(item, index)">{{item.title}}</p>
              </div>
              <div class="news-information-box-btn" @click="goToDynamicNews(2)">了解更多 ></div>
            </div>
            <div class="news-information-box-item">
              <div class="news-information-box-title">国联动态</div>
              <div class="news-information-box-content">
                <p v-for="(item,index) in newsList" :key="index" @click="handleGoNewsDetail(item, index)">{{item.title}}</p>
              </div>
              <div class="news-information-box-btn" style="color: #fff;background:#224CFF" @click="goToDynamicNews(1)">查看更多 ></div>
            </div>
          </div>
        </div>
        <div v-if="false" class="evaluation">领导评价</div>
        <div
          v-if="false"
          style="width: 1200px; margin: 0 auto; margin-bottom: 22px"
        >
          <div class="felxobx" style="justify-content: space-between">
            <div class="everboss-box">
              <div class="first-boss every-boss"></div>
              <div class="textaligncenter">
                <div class="left-png first-png"></div>
                独特的互联网发展模式和企业文化推动国联质检的快速发展值得学习和借鉴
                <div class="right-png last-png"></div>
              </div>
              <div class="boss-brief">
                <div>乔东</div>
                <div>原国家市场监督管理总局</div>
                <div>认可检测司副司长</div>
              </div>
            </div>
            <div class="everboss-box">
              <div class="two-boss every-boss"></div>
              <div class="textaligncenter">
                <div class="left-png two-first-png"></div>
                南有华测 北有谱尼 西有国联
                <div class="right-png two-last-png"></div>
              </div>
              <div style="right: 48px" class="boss-brief">
                <div>李文龙</div>
                <div>国家市场监督管理总局</div>
                <div>认可检测司处长</div>
              </div>
            </div>
          </div>
          <div class="felxobx" style="justify-content: space-between">
            <div class="everboss-box">
              <div class="stree-boss every-boss"></div>
              <div class="textaligncenter">
                <div class="left-png first-png"></div>
                以专业技术为基础 以认证检测为支撑 以共享经济为平台 心怀梦想
                回报社会
                <div class="right-png last-png"></div>
              </div>
              <div style="right: 44px" class="boss-brief">
                <div>刘先德</div>
                <div>国家市场监督管理总局</div>
                <div>认可与检测监管司副司长</div>
              </div>
            </div>
            <div class="everboss-box">
              <div class="four-boss every-boss"></div>
              <div class="textaligncenter">
                <div class="left-png first-png"></div>
                务实 开拓 创新 由小到大 传统到创新 线上到线下 由私到公偏项到专项
                平凡到伟大
                <div class="right-png last-png"></div>
              </div>
              <div style="right: 31px" class="boss-brief">
                <div>吴鹏</div>
                <div>国投检验检测认证有限公司</div>
                <div>投资总监</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="bottom-fixed">
        <div class="pc bottom-fixed" style="background: #081533">
          <div class="footbackround">
            <div class="foottext">
              <span>检测标准不清楚？检测价格没概念？</span>
            </div>
            <div
              @click="show53"
              style="cursor: pointer"
              id="consult-bottom"
              class="foot_botton"
            >
              马上咨询工程师
              <div class="jiantou"></div>
            </div>
            <div class="footmanbackround" />
          </div>
        </div>
      </div>
      <consultForm ref="consultForm" />
    </div>
    <!-- 移动端代码 -->
    <div v-if="pageType == 'mobile'">
      <home-mb />
    </div>
  </div>
</template>

<script>
(function () {
  if (document.documentElement.clientWidth > 960) {
    // 22222222
    // var _53code = document.createElement("script");
    // _53code.src = "https://tb.53kf.com/code/code/5cd60bbe34341ac131de2c0cddeef983/4";
    // var s = document.getElementsByTagName("script")[0];
    // s.parentNode.insertBefore(_53code, s);
  }
})();
import Banner from "@/components/swiper";
import HomeMb from "./HomeMb.vue";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.js";
// import 'swiper/dist/css/swiper.css'
// import pageHeader from "@/components/header";
import axios from "@/http";
import sampleDealStatus from "@/components/sampleDealStatus";
import laboratoryQuerySelect from "@/components/laboratoryQuerySelect";
import { Swiper as Vswiper, SwiperSlide, directive } from "vue-awesome-swiper";

export default {
  name: "home",
  computed: {
    commonClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "ph";
        case "sm":
          return "ph";
        case "md":
          return "pc";
        case "lg":
          return "pc";
        case "xl":
          return "pc";
      }
    },
  },

  metaInfo() {
    return {
      title: this.pageInfo.metaTitle, // set a title
      meta: [
        {
          // set meta
          name: "keyWords",
          content: this.pageInfo.metaKeywords,
        },
        {
          name: "description",
          content: this.pageInfo.metaDescription,
        },
      ],
    };
  },
  components: {
    Banner,
    pageHeader: () => import("@/components/header"),
    consultForm: () => import("@/components/consult"),
    HomeMb,
    sampleDealStatus,
    laboratoryQuerySelect,
    Vswiper,
    SwiperSlide,
  },
  watch: {
    $route() {
      this.type = this.$route.query.type;
      this.$refs.solution.scrollTop = 750;
    },
    labimageList() {
      setTimeout((r) => {
        new Swiper("#swiper2", {
          observer: true,
          loop: true,
          autoplay: true,
          slidesPerView: 6,
          slidesPerGroup: 1,
          spaceBetween: 10,
          speed: 2500, //滚动速度2500
          freeMode: true,
          autoplay: {
            //匀速滚动
            delay: 0, //间隔时间0秒
            stopOnLastSlide: false,
            disableOnInteraction: false, //触摸后仍然执行
          },
        });
      }, 0);
    },
    "hotProductData.length"() {
      setTimeout((r) => {
        new Swiper("#swiper0", {
          observer: true,
          loop: true,
          speed: 0,
          // 如果需要分页器
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }, 0);
    },
    "hotlistTab.length"() {
      setTimeout((r) => {
        new Swiper("#hotList", {
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination",
          },
        });
      }, 0);
    },
  },
  data() {
    return {
      labimageList: [],
      type: "",
      msg: "",
      isphoneIconShow: false,
      dialogVisible: false,
      isShowPro: false,
      isStrengthShow: false,
      strengthCurrent: 0,
      boom: null,
      current: 0,
      customersListpc: [],
      pageInfo: {
        metaTitle: "",
        metaKeywords: "",
        metaDescription: "",
      },
      contentsStyle: {
        width: "",
      },
      unqd_strength: [
        {
          id: 1,
          icon: require("@/assets/home/trophy.png"),
          url: require("@/assets/home/banner2.png"),
          select: require("@/assets/home/select_trophy.png"),
          desc: "CMA、CNAS、CATL、GLP、GCP等100多项资质荣誉",
        },
        {
          id: 2,
          icon: require("@/assets/home/peoples-two.png"),
          url: require("@/assets/home/banner1.png"),
          select: require("@/assets/home/select-peoples-two.png"),
          desc: "1000人精英专家团队10万+累计服务客户",
        },
        {
          id: 3,
          icon: require("@/assets/home/all-application.png"),
          url: require("@/assets/home/banner3.png"),
          select: require("@/assets/home/select-all-application.png"),
          desc: "42个业务领域，121个子类，600个产品，6111个参数指标",
        },
        {
          id: 4,
          icon: require("@/assets/home/building-four.png"),
          url: require("@/assets/home/banner4.png"),
          select: require("@/assets/home/select-building-four.png"),
          desc: "2万平米自有智能实验室，2800台高端仪器，200家国内外签约实验室",
        },
      ],
      contList: [
        {
          id: "1-1-1",
          name: "行业解决方案",
          type: 1,
          desc: "国联秉承满足并超越客户期望的客户价值导向原则，为多行业客户高质量发展保驾护航",
          mobiledesc: "为多行业客户高质量发展保驾护航",
        },
        {
          id: "",
          name: "国联硬实力",
          type: 2,
          desc: "依托专业的技术实力及优良的仪器设备，为企业提供多维度多场景服务支持",
          mobiledesc: "依托专业的技术实力、优良的仪器设备",
          moreList: [],
          imageList: [
            {
              url: "",
            },
          ],
          consociation: [],
          children: [],
        },
        {
          id: "",
          name: "行业客户",
          type: 3,
          desc: "国联创始至今，收获行业多方客户高度赞赏及认可",
          mobiledesc: "国联创始至今，收获行业多方客户高度赞赏及认可",
          moreList: [],
          imageList: [],
          consociation: [],
          children: [],
        },
      ],
      logoList: [
        {
          logoUrl: require("@/assets/logo1.png"),
          text: "检测流程",
        },
        {
          logoUrl: require("@/assets/logo2.png"),
          text: "服务中心",
        },
        {
          logoUrl: require("@/assets/logo3.png"),
          text: "相关资讯",
        },
      ],
      shadesList: [
        {
          num: "2011",
          unit: " 年",
          imgStatus: false,
          describe: "公司成立",
        },
        {
          num: "92",
          unit: " 个",
          imgStatus: false,
          describe: "检测大类",
        },
        {
          num: "20000",
          unit: " + m²",
          imgStatus: false,
          describe: "实验室",
        },
        {
          num: "100",
          unit: " + 项",
          imgStatus: false,
          describe: "专利&论文",
        },
        {
          imgUrl: require("@/assets/more_img.png"),
          imgStatus: true,
          describe: "了解更多",
        },
      ],
      jiejueList: [], // 行业解决方案
      hotlist: [], //热门检测列表
      hotlistTab: [], // 移动端-行业解决方案
      hotProductData: [], // 热门检测套餐
      eatMedicinelist: [], //食药检测列表
      oilslist: [], //油品检测列表
      materialslist: [], //材料检测列表
      chemicallist: [], //化工检测列表
      environmentlist: [], //环境检测列表
      pluslist: [], //更多检测列表
      menutitlelist: [], //菜单列表
      pageindex: 1,
      hotImgUrl: "",
      pagetotal: 12,
      customersList: [],
      pageType: "", // 页面类型 pc / mobile
      //实验室资质轮播图
      labroatoryQualityList:[],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 36,
        slidesPerGroup: 4,
        loop: true,
        //speed : 10000, //速度
        pagination: {
          el: ".labroatory-quality-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".labroatory-quality-swiper-button-next",
          prevEl: ".labroatory-quality-swiper-button-prev",
        },
        autoplay: {
          //匀速滚动
          delay: 2000, //间隔时间0秒
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
      },
      //联合实验室垂直轮播图
      lavoratorySwiperList:[],
      lavoratorySwiperOption: {
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 11,
        slidesPerGroup: 3,
        loop: true,
        //speed : 10000, //速度
        pagination: {
          el: ".labroatory-vertical-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".labroatory-vertical-swiper-button-next",
          prevEl: ".labroatory-vertical-swiper-button-prev",
        },
        autoplay: {
          //匀速滚动
          delay: 2000, //间隔时间0秒
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
      },
      //专家团队轮播图
      specialTeamSwiperList:[],
      specialTeamSwiperOption: {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerGroup: 2,
        navigation: {
          nextEl: ".special-team-swiper-button-next",
          prevEl: ".special-team-swiper-button-prev",
        },
        autoplay: {
          //匀速滚动
          delay: 2000, //间隔时间0秒
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        }
      },
      industryList:[],//行业资讯
      newsList:[]//国联动态
    };
  },
  beforeMount() {
    this.pageType = "pc";
    const width = document.documentElement.clientWidth;
    if (width < 934) {
      this.pageType = "mobile";
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    const obj = {
      platformType: 0,
      targetPage: "",
    };
    if (this.commonClass === "pc") {
      obj.platformType = 1;
    } else {
      obj.platformType = 2;
    }
    obj.targetPage = window.location.href;
    // const formData = new FormData()
    //   formData.append('platformType', obj.platformType)
    //   formData.append('platformType', obj.targetPage)
    // const config = {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // }
    this.$api.iotHome.loggingData(obj).then((res) => {
      if (res.data.success == true) {
        console.log("数据记录成功");
      }
    });

    this.$api.iotHome
      .hotProductlist({
        rows: 20,
        page: 1,
        hotFlag: 1,
        siteId: 0,
      })
      .then((res) => {
        if (res.data.success == true) {
          let arr = [];
          res.data.data.map((it, i) => {
            (it.index = i + 1 < 10 ? "0" + (i + 1) : i + 1),
              (it.jumpUrl = "/detectionDetail?id=" + it.relationId);
          });
          const tempArr = [];
          for (let index = 0; index < res.data.data.length; index++) {
            const obj = {
              prev:
                index === 0
                  ? res.data.data[res.data.data.length - 1]
                  : res.data.data[index - 1],
              current: res.data.data[index],
              next:
                index === res.data.data.length - 1
                  ? res.data.data[0]
                  : res.data.data[index + 1],
            };
            tempArr.push(obj);
          }
          this.hotProductData = tempArr;
        }
      });
    this.type = this.$route.query.type;
    // 行业解决方案
    this.$api.iotHome.getCategoryGroupList().then((res) => {
      if (res.data.success == true) {
        this.jiejueList = res.data.data.map((item, i) => {
          let arr = item.categoryClientList.map((s, d) => {
            return {
              ...s,
              isshow: d === 0,
            };
          });
          return {
            categoryClientList: arr,
          };
        });
      }
    });
    // 热门检测
    this.$api.iotHome
      .getIndustrySolutionList({
        parentId: 0,
      })
      .then((res) => {
        if (res.data.success == true) {
          var reslist = res.data.data;
          this.hotlist = reslist;
          const totalNum = reslist.length;
          const pageNum = 6;
          if (totalNum % pageNum == 0) {
            for (let index = 0; index < parseInt(totalNum / pageNum); index++) {
              this.hotlistTab.push(
                res.data.data.slice(index * 6, 6 * (index + 1))
              );
            }
          } else {
            for (
              let index = 0;
              index < parseInt(totalNum / pageNum) + 1;
              index++
            ) {
              this.hotlistTab.push(
                res.data.data.slice(index * 6, 6 * (index + 1))
              );
            }
          }
        }
      });
    // this.$api.iotHome.getImageList({ columnId: "1117" }).then((res) => {
    //   if (res.data.success == true) {
    //     this.hotImgUrl = this.$path + res.data.data.list[0].image;
    //   }
    // });
    // 获取检测的下级分类
    this.$api.iotHome
      .typelist({
        id: "",
        siteId: "0",
        detail: "aaa",
      })
      .then((res) => {
        if (res.data.success == true) {
          for (let i = 0; i < res.data.data.length; i++) {
            for (let j = 0; j < this.contList.length; j++) {
              if (this.contList[j].name == res.data.data[i].name) {
                this.contList[j].moreList = res.data.data[i].children;
              }
            }
          }
          // promise.all同时获取 每个检测内的4个检测子类以及每个检测对应的合作案例
          // this.getdetaillist();
        }
      });
    /* this.$api.iotHome.getLaboratoryImageList().then((res) => {
      if (res.data.success == true) {
        console.log(res.data.data,998)
        this.labimageList = res.data.data;
      }
    }); */
    this.$api.iotHome
      .getTdk({
        type: "0",
      })
      .then((res) => {
        if (res.data.success == true) {
          res.data.data.metaTitle = res.data.data.metaTitle.replace(
            /4008082011/g,
            "4008002318"
          );
          res.data.data.metaTitle = res.data.data.metaTitle.replace(
            /4008008511/g,
            "4008002318"
          );
          this.pageInfo = res.data.data;
        }
      });
    this.contentsStyle.width = this.$refs.home.clientWidth + "px";
    this.getIndustryCustomersList();
    this.getLabroatoryQualityList();
    this.getLavoratorySwiperList();
    this.getSpecialTeamSwiperList();
    this.getIndustryList();
    this.getNewsList();
  },
  methods: {
    //实验室资质
    getLabroatoryQualityList(page = 1,rows = 12){
      this.$api.iotHome.getQualificationData(page,rows).then(res=>{
        if (res.data.success == true) {
          this.labroatoryQualityList = res.data.data;
        }
      })
    },
    //实验室竖向轮播
    getLavoratorySwiperList(){
      this.$api.iotHome.getUniteLaboratoryImageList().then((res) => {
      if (res.data.success == true) {
          this.lavoratorySwiperList = res.data.data;
        }
      })
    },
    //专家团队轮播
    getSpecialTeamSwiperList(){
      this.$api.iotHome.getArticleList({
        columnId: 10705,
        rows: 999,
        page: 1,
        siteIds: 0,
      }).then(res=>{
        if (res.data.success == true) {
          this.specialTeamSwiperList = res.data.data.rows;
        }
      })
    },
    //行业资讯列表
    getIndustryList(page=1,rows=5){
      this.$api.iotHome.findNewsIndustryData(page,rows).then(res=>{
        if (res.data.success == true) {
          this.industryList = res.data.data.rows;
        }
      })
    },
    //国联动态列表
    getNewsList(page=1,rows=5){
      this.$api.iotHome.findDynamicNewsData(page,rows).then(res=>{
        if (res.data.success == true) {
          this.newsList = res.data.data.rows;
        }
      })
    },
    //前往新闻详情
    handleGoNewsDetail(data,index){
      data.outerUrl = data.outerUrl.replace(/\s*/g, "");
      if (data.outerUrl == "") {
        const { href } = this.$router.resolve({
          path: "/enterpriseDetail",
          query: {
            id: data.id,
            toDetailStatus: 1,
          },
        });
        window.open(href, "_blank");
      } else {
        window.open(data.outerUrl, "_blank");
      }
    },
    goToDynamicNews (obj) {
      this.$router.push({
          name: 'Enterprise',
          params: {
            idclickStatus: obj
          }
        })
    },
    jiejueListchange(o, t) {
      this.jiejueList[o].categoryClientList.map((it, d) => {
        if (d === t) {
          it.isshow = true;
        } else {
          it.isshow = false;
        }
      });
    },
    handleConsult() {
      const consultForm = this.$refs.consultForm;
      consultForm.$data.dialogVisible = true;
    },
    handleScroll(e) {
      var bady = document.getElementById("app");
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = Math.ceil(
        document.documentElement.scrollTop || document.body.scrollTop
      );
      // console.log(document.body.clientHeight)
      // console.log(scrollTop)
      //变量windowHeight是可视区的高度
      var windowHeight = bady.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = bady.scrollHeight;
      var showdome = document.getElementById("bottom-fixed");
      //滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight || scrollTop < 600) {
        //写后台加载数据的函数
        showdome ? (showdome.style.display = "none") : "";
      } else {
        showdome ? (showdome.style.display = "block") : "";
      }
    },
    show53() {
      const specs =
        "height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no";
      window.open(
        "https://tb.53kf.com/code/client/5cd60bbe34341ac131de2c0cddeef983/4",
        "_blank",
        specs
      );
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
    // 搜索
    searchChange() {},
    searchInput(val) {
      this.search = val;
    },
    tolist(data) {
      window.localStorage.setItem("defaultActive", data.id);
      this.$router.push({
        path: "/detection",
        query: {
          toDetailStatus: 1,
        },
      });
    },
    toDetail(data, index) {
      window.localStorage.setItem("defaultActive", data.type);
      this.$router.push({
        path: "/detection",
        query: {
          id: data.id,
          toDetailStatus: 1,
          menuStatus: index,
          status: 0,
        },
      });
    },
    // 国联硬实力
    handleStrength(index) {
      if (this.commonClass === "pc") {
        this.isStrengthShow = true;
        this.strengthCurrent = index;
      }
    },
    handleStrengthLeave(index) {
      if (this.commonClass === "pc") {
        this.isStrengthShow = false;
        this.strengthCurrent = index;
      }
    },
    // 移入
    handleMouseenter(index) {
      if (this.commonClass === "pc") {
        this.isShowPro = true;
        this.current = index;
      }
    },
    // 移出
    handleMouseleave(index) {
      if (this.commonClass === "pc") {
        this.isShowPro = false;
        this.current = index;
      }
    },
    // 行业客户
    getIndustryCustomersList() {
      const _that = this;
      this.$api.iotHome
        .getArticleList({
          columnId: 102,
          rows: 20,
          page: 1,
        })
        .then((res) => {
          if (res.data.success == true) {
            this.customersList = res.data.data.rows;
            let arr = res.data.data.rows;
            if (arr.length > 18) {
              arr.length = 18;
            }
            this.customersListpc = [...arr];
          }
        });
    },
    golist(data) {
      window.localStorage.setItem(
        "defaultActive",
        data.consociation[0].columnId
      );
      this.$router.push({
        path: "/cooperation",
        query: {
          toDetailStatus: 1,
        },
      });
    },
    toArticleList(data) {
      window.localStorage.setItem("defaultActive", data.columnId);
      this.$router.push({
        path: "/cooperationDetail",
        query: {
          id: data.id,
          toDetailStatus: 1,
        },
      });
    },
    toNewsDetail(data) {
      if (data.outerUrl != "") {
        window.open(data.outerUrl, "_target_");
      } else {
        window.localStorage.setItem("defaultActive", data.columnId);
        this.$router.push({
          path: "/enterpriseDetail",
          query: {
            id: data.id,
            toDetailStatus: 1,
          },
        });
      }
    },
    toNewsList(data, index) {
      window.localStorage.setItem(
        "defaultActive",
        data.contentList[0].columnId
      );
      if (index == 1) {
        this.$router.push({
          path: "/popularization",
          query: {
            toDetailStatus: 1,
          },
        });
      } else {
        this.$router.push({
          path: "/enterprise",
          query: {
            toDetailStatus: 1,
          },
        });
      }
    },
    toscienceDetail(data) {
      window.localStorage.setItem("defaultActive", data.columnId);
      this.$router.push({
        path: "/popularizationDetail",
        query: {
          id: data.id,
          toDetailStatus: 1,
        },
      });
    },
    todownloadlist(data) {
      window.localStorage.setItem("defaultActive", "10403");
      this.$router.push({
        path: "/popularization",
        query: {
          toDetailStatus: 1,
        },
      });
    },
    moveTo() {
      this.$router.push({
        path: "/aboutMe",
        query: {
          toDetailStatus: 1,
        },
      });
    },
    handleClose(done) {
      done();
    },
    downloadFile(data) {
      this.$api.iotHome
        .downloadFile({
          fileId: data.id,
        })
        .then((res) => {
          console.log(res);
        });
    },
    // 获取检测list
    getlist(data) {
      return this.$api.iotHome.list(data);
    },
    // 获取对应的合作案例
    getArticleList(data) {
      return this.$api.iotHome.getArticleList(data);
    },
    movetolist(data) {
      window.localStorage.setItem("defaultActive", data.id);
      this.$router.push({
        path: "/detection",
        query: {
          toDetailStatus: 1,
        },
      });
    },
    download(data) {
      // window.location.href = this.$path + "/web/cms/download?fileId=" + data.id;
      window.localStorage.setItem(
        "pathUrl",
        this.$path + "/web/cms/download?fileId=" + data.id
      );
      this.dialogVisible = true;
    },
    onSuccess() {
      this.dialogVisible = false;
      this.$refs.slideblock.reset();
      this.msg = "";
      window.location.href = window.localStorage.getItem("pathUrl");
    },
    onFail() {
      this.msg = "";
    },
    onRefresh() {
      this.msg = "";
    },
    pageChange(val) {
      // 热门检测
      this.getlist({
        type: "",
        page: val,
        rows: 10,
        hotFlag: "1",
      }).then((res) => {
        if (res.data.success == true) {
          this.pagetotal = parseInt(res.data.code);
          var reslist = res.data.data;
          this.hotlist = reslist;
        }
      });
    },
    getdetaillist() {
      var p1 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10201",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p2 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10202",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p3 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10203",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p4 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10204",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p5 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10205",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p6 = new Promise((resolve, reject) => {
        this.getArticleList({
          columnId: "10206",
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p7 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[2].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p8 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[3].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p9 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[4].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p10 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[5].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p11 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[6].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      var p12 = new Promise((resolve, reject) => {
        this.getlist({
          type: this.contList[7].id,
          page: 1,
          rows: 4,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
      Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12]).then(
        (res) => {
          if (res[0].data.success == true) {
            this.contList[2].consociation = res[0].data.data.rows;
          }
          if (res[1].data.success == true) {
            this.contList[3].consociation = res[1].data.data.rows;
          }
          if (res[2].data.success == true) {
            this.contList[4].consociation = res[2].data.data.rows;
          }
          if (res[3].data.success == true) {
            this.contList[5].consociation = res[3].data.data.rows;
          }
          if (res[4].data.success == true) {
            this.contList[6].consociation = res[4].data.data.rows;
          }
          if (res[5].data.success == true) {
            this.contList[7].consociation = res[5].data.data.rows;
          }
          if (res[6].data.success == true) {
            this.eatMedicinelist = res[6].data.data;
          }
          if (res[7].data.success == true) {
            this.oilslist = res[7].data.data;
          }
          if (res[8].data.success == true) {
            this.materialslist = res[8].data.data;
          }
          if (res[9].data.success == true) {
            this.chemicallist = res[9].data.data;
          }
          if (res[10].data.success == true) {
            this.environmentlist = res[10].data.data;
          }
          if (res[11].data.success == true) {
            this.pluslist = res[11].data.data;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* 手机端 */
@media all and (max-width: 960px) {
  .ph {
    display: flex !important;
  }
  .pc {
    display: none !important;
  }
  .detection_solution {
    .ever_content1 {
      display: none !important;
    }
  }
  .detection_solution {
    .hotList {
      display: block !important;
    }
  }
}
/* PC端 */
@media all and (min-width: 960px) {
  .ph {
    display: none !important;
  }
  .pc {
    display: flex !important;
  }
  .detection_solution {
    .ever_content1 {
      display: flex !important;
      width: 1200px !important;
      margin: 0 auto;
    }
  }
  .detection_solution {
    .hotList {
      display: none !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@import url("../style/home.css");
.left-png {
  position: relative;
  width: 20px;
  height: 20px;
  background: url("../assets/left.png");
  background-size: 100% 100%;
}

.right-png {
  position: relative;
  width: 20px;
  height: 20px;
  background: url("../assets/right.png");
  background-size: 100% 100%;
}
#bottom-fixed {
  display: none;
}
.bottom-fixed {
  height: 100px;
  width: 100%;
  position: fixed;
  right: 0px;
  bottom: 0px;
  opacity: 0.91;
  z-index: 99999;
  .footbackround {
    width: 1920px;
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: url("../assets/fixed-foot.png");
    .foottext {
      position: absolute;
      top: 37px;
      left: 505px;
      width: 390px;
      font-size: 21px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      line-height: 30px;
      font-style: oblique;
      span {
        display: inline-block;
      }
    }
    .foot_botton {
      position: absolute;
      width: 246px;
      height: 40px;
      padding-left: 27px;
      background: #ff9a22;
      border-radius: 27px;
      top: 30px;
      left: 910px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 40px;
      color: #ffffff;
      .jiantou {
        position: absolute;
        width: 30px;
        height: 25px;
        top: 8px;
        right: 25px;
        background: url("../assets/jiantou.png");
        background-size: cover;
      }
    }
    .footmanbackround {
      width: 114px;
      height: 127px;
      background: url("../assets/fixed-man.png");
      position: absolute;
      top: -27px;
      right: 508px;
      background-size: cover;
    }
  }
}
.boss-brief {
  position: absolute;
  right: 38px;
  top: 53px;
  text-align: center;
}
.boss-brief :nth-child(1) {
  margin-right: 0 !important;
  font-size: 24px;
  font-weight: bold;
}
.textaligncenter {
  position: absolute;
  width: 232px;
  top: 50%;
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: #282b45;
  left: 84px;
  transform: translateY(-50%);
  .first-png {
    left: -34px;
  }
  .last-png {
    right: -231px;
  }
  .two-first-png {
    right: 38px;
    top: 23px;
  }
  .two-last-png {
    right: -242px;
    top: -22px;
  }
}
.everboss-box {
  position: relative;
  width: 584px;
  height: 170px;
  background: #fff;
  border-radius: 14px;
}
.first-boss {
  background: url("../assets/qiaodong.jpg") no-repeat center;
}
.two-boss {
  background: url("../assets/liwenlong.jpg") no-repeat center;
}
.stree-boss {
  background: url("../assets/liuxiande.jpg") no-repeat center;
}
.four-boss {
  background: url("../assets/wupeng.jpg") no-repeat center;
}
.felxobx {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 72px;
}
.felxobx :nth-child(1) {
  margin-right: 28px;
}
.every-boss {
  position: absolute;
  top: -53px;
  right: 40px;
  width: 100px;
  height: 100px;
  background-size: 100%;
  border-radius: 50%;
}

.evaluation {
  width: 144px;
  height: 35px;
  font-size: 36px;
  margin-top: 100px;
  margin-bottom: 96px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 25px;
}
.forinchain {
  width: 247px;
  height: 35px;
  font-size: 35px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 25px;
  margin: 100px auto 0;
}
.forinchain-title {
  height: 18px;
  margin-top: 25px;
  margin-bottom: 50px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #777a95;
  line-height: 25px;
}
.cooperative-partner {
  width: 600px;
  height: 35px;
  margin-top: 70px;
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282b45;
  line-height: 25px;
}
.cooperative-partner-title {
  width: 600px;
  height: 18px;
  margin-top: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #777995;
  line-height: 25px;
  opacity: 0.6;
}
.blue-center {
  width: 100%;
  height: 236px;
  margin-top: 282px;
  position: relative;
  background: #4065ff;
}
.advisory-title {
  width: 310px;
  height: 54px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  color: #f9faff;
  line-height: 54px;
  font-weight: 500;
  background: #ff9a22;
  border-radius: 38px;
  margin: 50px auto 70px;
}
.allset {
  position: absolute;
  cursor: pointer;
  width: 31px;
  color: #fff;
  line-height: 31px;
  height: 170px;
  background: #224cff;
  font-weight: 500;
  font-size: 16px;
  word-spacing: 0px;
  border-radius: 0px 16px 16px 0px;
  top: 193px;
  right: -31px;
  writing-mode: tb-rl;
}
.allset-inner {
  display: inline-block;
  width: 19px;
  height: 19px;
  line-height: 20px;
  border: 1px solid #ffffff;
  border-radius: 50%;
}
.transition-box {
  transition: all 1s;
}
.activebox {
  width: 269px;
  height: 554px;
  background: #f1f1f1;
  .item-imageshadow {
    width: 0px;
  }
  .item-image {
    width: 0px;
  }
  .index {
    position: relative;
    top: 134px;
    left: 45px;
    width: 60px;
    font-size: 60px;
    height: 60px;
    line-height: 1;
    font-weight: 400;
    color: #3d4056;
    opacity: 0.3;
  }
  .item-name {
    position: relative;
    top: 221px;
    left: 45px;
    font-size: 26px;
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #3d4056;
  }
  .yellow-border {
    position: relative;
    top: 260px;
    left: 45px;
    width: 34px;
    height: 6px;
    background: #ff9a22;
  }
  .to-details {
    display: none;
  }
  .item-center {
    position: relative;
    top: 294px;
    left: 45px;
    width: 179px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
}
.change-box {
  width: 634px;
  height: 554px;
  background: linear-gradient(0deg, #4064ff 0%, #617fff 100%);
  box-shadow: 0px 10px 20px 0px rgba(94, 97, 108, 0.3);
  .item-image {
    position: relative;
    top: 45px;
    left: 53px;
    width: 390px;
    z-index: 33;
    height: 234px;
    transition: all 1s;
  }
  .item-imageshadow {
    position: relative;
    top: -155px;
    left: 193px;
    width: 390px;
    height: 225px;
    z-index: 30;
    background: #ffffff;
    opacity: 0.1;
    transition: all 1s;
  }
  .index {
    position: relative;
    top: -137px;
    left: 45px;
    width: 84px;
    height: 84px;
    line-height: 1;
    font-weight: 400;
    color: #ffffff;
    font-size: 80px;
    opacity: 0.4;
  }
  .to-details {
    display: block;
    position: relative;
    width: 127px;
    cursor: pointer;
    height: 34px;
    border: 1px solid #ffffff;
    border-radius: 17px;
    top: -226px;
    font-size: 18px;
    line-height: 30px;
    color: #fff;
    left: 454px;
  }
  .item-name {
    position: relative;
    top: -188px;
    left: 160px;
    text-align: left;
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
  }
  .item-center {
    position: relative;
    top: -178px;
    text-align: left;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    left: 45px;
    width: 544px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
  }
}
.ph {
  width: calc(100% - 32px);
  margin-left: 16px;
  .m_product {
    display: flex;
  }
  .contents_box {
    width: 100%;
  }
  .contents_ever {
    width: 100%;
    margin-top: 32px;
    .ever_content1 {
      width: 100%;
    }
    .ever_title_left_title {
      .ever_title_left_text {
        font-size: 20px;
        font-family: "PingFangSC, PingFangSC-Medium";
        font-weight: 500;
        color: #1e203c;
      }
      p {
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: #777a95;
        margin-top: 12px;
        margin-bottom: 24px;
      }
    }
    .col_ever {
      // width: 48%;
      height: 110px;
      position: relative;
      margin-top: 16px;
      .col_ever_text {
        text-align: left;
        text-indent: 12px;
        width: 100%;
        padding: 8px 0;
        color: #fff;
        font-size: 12px;
        font-family: "PingFangSC-Medium";
        font-weight: 500;
        position: absolute;
        bottom: 0;
        border-radius: 0 0 3px 3px;
        background: rgba(0, 0, 0, 0.45);
        .col_ever_title {
          padding: 0;
        }
      }
      .col_ever_img {
        border-radius: 3px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .unqd_strength_box {
      width: 100%;
      margin-top: 32px auto 0 auto;
      .unqd_strength {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-flow: wrap;
        position: relative;
        width: 100%;
        li {
          width: 50%;
          .unqd_strength_cont {
            margin-top: 50px;
            position: absolute;
            img {
              width: 39.5px;
              height: 37.5px;
              margin: 0 auto 28px auto;
            }
            .unqd_strength_cont_desc {
              width: calc(100% - 42px);
              margin-left: 21px;
              font-size: 12px;
              font-family: "PingFangSC";
              font-weight: 400;
              text-align: left;
              color: #ffffff;
            }
          }
        }
      }
    }
    .industry_customers {
      width: 100%;
      margin-bottom: 32px;
      ul {
        width: 100%;
        display: flex;
        flex-flow: wrap;
        li {
          width: 33%;
          height: 59px;
          border-bottom: 1px solid #eaebee;
          border-right: 1px solid #eaebee;
          &:nth-child(3n) {
            border-right: none;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.pc {
  background: #f3f4f9;
  .contents_ever {
    width: 100% !important;
    margin-top: 56px;
  }
  .show53 {
    width: 360px;
    height: 54px;
    margin: 50px 0;
    text-align: center;
    background: #ff9a22;
    border-radius: 38px;
    font-size: 26px;
    font-weight: 500;
    color: #f9faff;
    line-height: 54px;
  }
  .ever_title_left_text {
    color: #282b45;
    font-size: 32px;
    line-height: 1;
    font-weight: bold;
  }
  .contents_box:nth-child(1) {
    .contents_ever {
      .ever_title_left_title {
        p {
          margin: 13px 0 20px;
        }
      }
    }
    .contents_nav {
      width: 1260px !important;
      padding: 0 50px;
      overflow: auto;
      margin-top: 50px;
      div {
        cursor: pointer;
        float: left;
        color: #282b45;
        font-size: 20px;
        line-height: 1;
        margin-left: 65px;
        padding-bottom: 16px;
      }
      div:nth-child(1) {
        margin-left: 0px;
      }
      .active {
        color: #4064ff;
        border-bottom: 4px solid #4064ff;
      }
      &.contents_nav-first {
        margin-top: 39px;
      }
    }
    .detection_solution {
      .ever_content1 {
        background: #fff;
        width: 1300px !important;
        padding: 50px;
      }
    }
    .solution_level {
      .solution_level_box {
        position: relative;
        width: 1260px !important;
        padding: 30px;
        background: #fff;
        height: 573px;
        .solution_level1 {
          width: 323px;
          height: 100%;
          background-size: cover;
          position: relative;
          &:hover {
            box-shadow: 1px 2px 15px rgb(0 0 0 / 25%);
          }
          .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(
              rgba(255, 255, 255, 0) 20%,
              rgba(1, 5, 28, 0.7) 80%
            );
          }
          .desc {
            position: absolute;
            width: 100%;
            bottom: 56px;
            color: #ffffff;
            span {
              width: 220px;
              display: inline-block;
              text-align: left;
            }
            .desc1 {
              font-size: 26px;
              font-weight: 800;
              color: #ffffff;
              line-height: 1;
            }
            .desc2 {
              margin-top: 30px;
              margin-left: 52px;
              font-size: 14px;
              font-weight: 500;
              color: #ffffff;
              height: 60px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              display: -webkit-box;
              -webkit-line-clamp: 3;
            }
            .desc3 {
              margin-top: 36px;
              .more_btn {
                display: inline-block;
                width: 110px;
                height: 30px;
                line-height: 30px;
                background: #224cff;
                color: #fff;
                text-align: center;
                border-radius: 4px;
              }
            }
          }
        }
        .solution_level2 {
          top: 30px;
          left: 370px;
          position: absolute;
          width: 860px;
          height: 513px;
          .solution_level2_item {
            border: 1px solid #d7d8df;
            width: 280px;
            height: 250px;
            float: left;
            margin-left: 10px;
            margin-bottom: 13px;
            display: flex;
            flex-direction: column;
            align-items: center;
            &:hover {
              box-shadow: 1px 2px 10px rgb(0 0 0 / 20%);
            }
            .level2_item_image {
              background-size: cover;
              width: 278px;
              height: 167px;
              margin-bottom: 22px;
            }
            .level2_item_center1 {
              max-width: 278px;
              overflow: hidden;
              height: 18px;
              text-align: center;
              font-size: 18px;
              // font-family: Source Han Sans CN;
              font-weight: 500;
              color: #282b45;
              line-height: 18px;
            }
            .level2_item_center2 {
              margin-top: 10px;
              width: 100%;
              padding: 0 30px;
              overflow: hidden;
              height: 20px;
              font-size: 14px;
              font-weight: 500;
              color: #a2a3b4;
              line-height: 20px;
            }
          }
        }
        .solution_level2 :nth-child(3n + 1) {
          margin-left: 0 !important;
        }
      }
    }
  }
  .bigswiper-center {
    width: 100%;
    min-width: 1200px;
    padding-bottom: 100px;
    background: url("../assets/hot_set.jpg") no-repeat center;
    background-size: 100% 100%;
    .hot-set-inner {
      width: 340px;
      height: 54px;
      font-size: 26px;
      margin: 0 auto;
      margin-top: 46px;
      font-weight: 500;
      color: #f9faff;
      line-height: 54px;
      background: #ff9a22;
      border-radius: 38px;
    }
    .bigswiper-center-title {
      width: 216px;
      height: 35px;
      margin: 0 auto;
      margin-top: 100px;
      font-size: 36px;
      font-weight: 700;
      color: #ffffff;
      line-height: 25px;
    }
    .bigswiper-center-inner {
      width: 504px;
      height: 18px;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 55px;
      font-size: 18px;
      font-weight: 500;
      color: #cacbdd;
      line-height: 18px;
    }
    .toall {
      position: relative;
      width: 1200px;
      height: 642px;
      margin: 0 auto;
    }
    .swiper-container {
      width: 1200px;
      height: 642px;
    }
    .swiper-slides-item {
      width: 1200px;
      display: flex;
      align-items: center;
      height: 554px;
      justify-content: center;
    }
    .swiper-button-prev,
    .swiper-button-next {
      width: 40px;
      height: 40px;
      background-size: 18px 18px;
      border: 2px solid #fff;
      background-color: rgba(0, 0, 0, 0);
      top: 97%;
      color: #1e203c;
    }
    .swiper-button-prev {
      left: 43%;
    }
    .swiper-button-next {
      right: 43%;
    }
    .swiper-button-prev:focus {
      outline: none;
    }
    .swiper-button-next:focus {
      outline: none;
    }
  }
}
.hotList {
  width: 100%;
  .swiper-wrapper {
    margin-bottom: 52px;
    .swiper-slide {
      display: flex;
      flex-flow: wrap;
      justify-content: space-between;
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.swiper-container .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
.swiper-pagination {
  .swiper-pagination-bullet {
    width: 40px;
    height: 3px;
    opacity: 1;
    background: #1e203c;
    border-radius: 1px;
    opacity: 0.2;
  }
  .swiper-pagination-bullet-active {
    width: 40px;
    height: 3px;
    opacity: 1;
    background: #008cff;
    border-radius: 1px;
  }
}
</style>
<style lang="scss">
.sample_deal_status {
  position: absolute;
  top: 42%;
  left: 74%;
  transform: translate(-50%, -50%);
  z-index: 301;
}
.laboratory_query_banner {
  position: absolute;
  bottom: 0;
  z-index: 300;
}
.labroatory-quality {
  padding-top: 50px;
  .title-header {
    margin-bottom: 40px;
    .title {
      color: #282b45;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      font-weight: bold;
    }
    .tip {
      color: #777995;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
  .swiper-warpper {
    height: 378px;
  }
  .labroatory-quality-swiper-pagination {
    position: relative;
    top: 21px;
    .swiper-pagination-bullet {
      width: 60px;
      height: 2px;
      border-radius: 0;
    }
    .swiper-pagination-bullet-active {
      height: 4px;
      position: relative;
      top: 1px;
    }
  }
  .labroatory-quality-swiper-button-next,
  .labroatory-quality-swiper-button-prev {
    width: 32px;
    height: 32px;
    border: 1px solid #224cff;
    color: #224cff;
    text-align: center;
    font-size: 20px;
    line-height: 32px;
    border-radius: 50%;
    display: inline-block;
    font-weight: bold;
    margin-left: 14px;
    position: relative;
    z-index: 999;
  }
  .swiper-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .msg {
      color: #777995;
      font-size: 14px;
      line-height: 40px;
    }
  }
}
.labroatory-show {
  background: #fff;
  width: 100%;
  height: 767px;
  padding-top: 137px;
  display: flex;
  justify-content: center;
  position: relative;
  .labroatory-banner {
    position: absolute;
    height: 137px;
    width: 100%;
    top: 0;
    background-image: url("~@/assets/laboratory/header.png");
    background-size: cover;
    display: flex;
    justify-content: center;
    .labroatory-banner-logo {
      height: 100%;
      width: 272px;
    }
    .labroatory-banner-title {
      height: 100%;
      width: 988px;
      line-height: 137px;
      font-size: 28px;
      font-weight: bold;
      color: #fff;
    }
  }
  .labroatory-content {
    width: 1200px;
    height: 100%;
    position: relative;
    .labroatory-content-map {
      position: absolute;
      bottom: 70px;
      left: 250px;
      width: 686px;
      height: 507px;
    }
    .labroatory-content-text {
      position: absolute;
      bottom: 104px;
      left: 0;
      text-align: left;
      .labroatory-content-text-title {
        font-size: 38px;
        font-weight: bold;
        color: #282b45;
        line-height: 30px;
        margin-bottom: 19px;
      }
      .labroatory-content-text-tip {
        font-size: 22px;
        color: #777a95;
        line-height: 30px;
        margin-bottom: 60px;
      }
      .labroatory-content-text-btn {
        width: 183px;
        height: 40px;
        background: #224cff;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
    .labroatory-content-swiper {
      width: 260px;
      height: 500px;
      position: absolute;
      bottom: 76px;
      right: 0;
      .labroatory-vertical-swiper-pagination {
        width: 8px;
        position: absolute;
        top: 0;
        right: 10px;
      }
      .btns {
        position: absolute;
        bottom: 0;
        right: 0;
        div {
          width: 30px;
          height: 30px;
          background: #000000;
          opacity: 0.3;
          border-radius: 50%;
          line-height: 30px;
          text-align: center;
          color: #fff;
          margin-top: 20px;
        }
      }
    }
  }
}
.special-team {
  width: 100%;
  height: 574px;
  background: url("~@/assets/laboratory/special-list.jpg");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .special-team-box {
    width: 1260px;
    height: 100%;
    padding-top: 50px;
    .special-team-text {
      margin-bottom: 40px;
      .special-team-title {
        font-size: 32px;
        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
      }
      .special-team-tip {
        font-size: 14px;
        color: #a2a3b4;
        line-height: 40px;
      }
    }
    .special-team-swiper {
      width: 100%;
      height: 297px;
      .special-team-swiper-item {
        background: linear-gradient(0deg, #2b2c30 0%, #38393d 100%);
        overflow: hidden;
        img {
          position: relative;
          top: 20px;
          left: 20px;
          height: 297px;
        }
      }
    }
    .btns {
      margin-top: 30px;
      div {
        display: inline-block;
        width: 44px;
        height: 44px;
        border: 1px solid #ffffff;
        border-radius: 50%;
        color: #fff;
        line-height: 44px;
        text-align: center;
        font-size: 24px;
      }
      .special-team-swiper-button-next {
        margin-left: 60px;
      }
    }
  }
}
.news-information {
  width: 100%;
  height: 498px;
  padding-top: 50px;
  display: flex;
  justify-content: center;
  .news-information-box {
    width: 1200px;
    display: flex;
    justify-content: space-between;
  }
  .news-information-box-item {
    width: 591px;
  text-align: left;
    .news-information-box-title {
      height: 30px;
      font-size: 32px;
      font-weight: bold;
      color: #282b45;
      line-height: 40px;
      margin-bottom: 20px;
    }
    .news-information-box-content {
      width: 591px;
      height: 290px;
      background: #ffffff;
    }
    .news-information-box-btn {
      margin-top:18px;
      width: 117px;
      height: 30px;
      border: 1px solid #224cff;
      color: #224cff;
      line-height:30px;
      text-align: center;
      box-shadow: 0px 8px 12px 0px rgba(34, 76, 255, 0.13);
      cursor: pointer;
    }
    .news-information-box-content{
      padding:40px;
      p{
        color: #282B45;
        line-height: 42px;
        font-size: 16px;
        border-bottom:1px dashed #ccc;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p:hover{
        color:#224CFF;
        border-bottom:1px solid #ccc
      }
    }
  }
}
</style>
